const FORMULA_PREFIXES = ['=', '+', '-', '@', '\t', '\r']

const sanitizeValue = (value) => {
    if (typeof value !== 'string' || value.length === 0) return value
    return FORMULA_PREFIXES.includes(value[0]) ? "'" + value : value
}

export const sanitizeExportData = (data) =>
    data.map(row =>
        Object.fromEntries(
            Object.entries(row).map(([key, value]) => [key, sanitizeValue(value)])
        )
    )
